<template>
    <div>

        <vue-headful title="View Alert :: MeritEHS"/>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/alerts`">
                            <i class="fa fa-bell"></i> Alerts
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ alert.subject }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8">
                    <div class="card">
                        <div class="card-header">Alert Message</div>
                        <div class="card-body">
                            <div v-html="alert.message"></div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="card">
                        <div class="card-header">Alert Details</div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-lg-4 text-muted text-lg-right">Created By:</div>
                                <div class="col-lg-8">
                                    <span v-if="alert.creator_id">{{ alert.FirstName }} {{ alert.LastName }}</span>
                                    <span v-else>System</span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-4 text-muted text-lg-right">Created At:</div>
                                <div class="col-lg-8">
                                    {{ alert.created_at_formatted }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 text-muted text-lg-right">Read At:</div>
                                <div class="col-lg-8">
                                    {{ alert.read_at_formatted }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                alert_id: this.$route.params.id,
                alert: {},
            }
        },

        methods: {
            getAlert() {
                //Get the data
                this.$http
                    .get('/alerts/view/' + this.alert_id)
                    .then(response => {
                        //Set all the data
                        this.alert = response.data.alert;

                        //Emit what's read
                        this.$store.commit('markAlertRead', this.alert.id);
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },
        },

        mounted() {
            //Get the MIC
            this.getAlert();
        }
    }
</script>
